import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { inputLabel } from '../input/input.css';
import { style } from '../layer.css';

// TODO: review styles for SegmentedSlider and merge common ones

const trackHeight = 4;
const thumbSize = 24;

export const sliderContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const slider = style({
  display: 'flex',
  position: 'relative',
  userSelect: 'none',
  touchAction: 'none',
  alignItems: 'center',

  marginBottom: (thumbSize - trackHeight) / 2,

  selectors: {
    '&[data-disabled]': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
  },
});

export const sliderFieldLabel = style([
  inputLabel,
  {
    marginBottom: space.s12,
  },
]);

export const sliderTrack = style({
  position: 'relative',

  backgroundColor: themeVars.slider.background.default,
  borderRadius: borderRadius.r4,
  flexGrow: 1,
  height: trackHeight,
});

export const sliderRange = style({
  position: 'absolute',
  backgroundColor: themeVars.slider.foreground.default,
  borderRadius: borderRadius.r12,
  height: '100%',
});

export const sliderThumb = style({
  display: 'block',
  height: thumbSize,
  width: thumbSize,
  backgroundColor: themeVars.slider.foreground.default,
  border: `1px solid ${themeVars.slider.background.default}`,
  borderRadius: '100%',
  filter: 'drop-shadow(0 2px 3px rgba(0, 0, 0, 0.1))',
  transform: 'translateZ(0)',
});

export const sliderLabel = style({
  ...typography['labelMd'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: themeVars.container.foreground.tertiary,
});

export const valueLabel = style({
  ...typography['labelMd'],
  color: themeVars.slider.foreground.default,
  backgroundColor: themeVars.slider.background.default,
  padding: `${space.s2}px ${space.s8}px`,
  borderRadius: '60px',
  opacity: 0,
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  position: 'absolute',
  left: '50%',
  top: -space.s8,
  transform: 'translate(-50%, -98%) scale(0.96)',

  transition: 'opacity 150ms',

  selectors: {
    [`${sliderThumb}:hover &, ${sliderThumb}:focus-visible &`]: {
      opacity: 1,
      transform: 'translate(-50%, -100%) scale(1)',
    },
  },
});
